export function getCookie(name: string) {
  try {
    return document.cookie.split('; ').find((row) => row.startsWith(name))
  } catch (e) {
    return undefined
  }
}

// NOTE: getCookieに似ていますが、try-catchする必要性とundefinedを返す点が気になるので別な関数として追加しました。
export function getCookieRow(name: string): string {
  const cookieRow = document.cookie
    .split('; ')
    .find((row) => row.startsWith(name))
  return `${cookieRow}` || ''
}

export function getCookieValue(name: string): string {
  const row = getCookieRow(name)
  if (!row) return ''
  const value = row.split('=')[1]
  if (value == null) return ''
  return `${value}`
}

export function setSearchConditionCookie(name: string, params: any) {
  try {
    document.cookie = `${name}=${encodeURIComponent(
      JSON.stringify(params)
    )}; max-age=31536000; path=/`
  } catch (e) {
    console.error(e)
  }
}
